<!--酒店列表已搜索条件-->
<template>
  <div>
    <div class="search-criteria">
        <p class="location-title">当前筛选条件:</p>
        <ul class="location-list">
            <!--区域酒店-->
            <template v-for="(item,i) in blocks()">
                <li  :key="i" v-if="searcValue.district==item.id" @click="clickItem('clickItem',1)">{{item.landmark||item.title}}<i class="el-icon-close"></i></li>
                <li  :key="i+1" v-if="searcValue.lon_latName==item.landmark" @click="clickItem('lon_lat',1)">{{item.landmark||item.title}}<i class="el-icon-close"></i></li>
            </template>
            <template v-for="(item,i) in SearchCriteriaList">
                <template v-for="item2 in item.list">
                    <li   :key="`single-${i}-${item2.id}`" v-if="!item.isMulti&&searcValue[item.valueKey]==(item2.id||item2.pinyin)" @click="clickItem(item.valueKey,'')">{{item2.name||item2.pinyin}}<i class="el-icon-close"></i></li>
                    <li  :key="`multi-${i}-${item2.id}`" v-if="item.isMulti&&searcValue[item.valueKey].includes(item2.id)" @click="clickItem(item.valueKey,item2.id,true)">{{item2.name}}<i class="el-icon-close"></i></li>
                </template>
                <li v-if="item.valueKey=='room_2_range'&&item.valueKeysearcValue" :key="i"  @click="clickItem(item.valueKey,'')">{{ (item.valueKeysearcValue[item.valueKey] || '').replace(/,/g, '~') }}间<i class="el-icon-close"></i></li>
            </template>
        </ul>
        <div class="clear" @click="learConditions()"><i class="el-icon-delete"></i>清空条件</div>
    </div>
  </div>
</template>

<script>
import {mapActions,mapState} from 'vuex'
import LocationData from '@/assets/utils/LocationData.json'   //城市的商圈景点等位置信息
import provinces from '@/assets/utils/provinces'             //省份信息
export default {
  name: 'SearchCriteria',
  components: {},
  props: {
    searcValue: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        SearchCriteriaList:[
            {name:'酒店星级',list:this.$GVAR.HotelStar.slice(2,9),valueKey:'star',isMulti:true},
            {name:'住宿类型',list:this.$GVAR.StyleLabel,valueKey:'type',isMulti:false},
            {name:'酒店双床房',list:this.$GVAR.twinRoomQuantity,valueKey:'room_2_type',isMulti:false},
            {name:'酒店双床房区间',list:this.$GVAR.twinRoomQuantity,valueKey:'room_2_range',isMulti:false},
            {name:'酒店首字母',list:this.$GVAR.SearchInitialList,valueKey:'pinyin',isMulti:false},
            {name:'酒店品牌',list:this.$GVAR.FacilitiesPlatform.flatMap(item => item.brand),valueKey:'brand',isMulti:false},
        ]
    };
  },
  computed: {
       ...mapState(['SearchInitialList']),
  },
  watch: {
    SearchInitialList(newVal,oldVal){
        // this.SearchCriteriaList[3].list = newVal;
        console.log(this.SearchCriteriaList,6677);
    }
  },
  created() {},
  mounted() {},
  methods: {
        //获取城市信息
        blocks(){
            let Arr = [];   
            if(this.searcValue.cityType == '1'){
                Arr = provinces.filter(item => item.up == this.searcValue.cityId);
                console.log(Arr);
            }else{
                Arr = LocationData[this.searcValue.cityId] ? LocationData[this.searcValue.cityId][this.searcValue.cityType] : [];
            }
            return Arr||[];
        },
        //点击地区信息
        clickItem(item,type,isMulti=false){
            //双床房区间
            if(item=='room_2_range'){
                this.$emit('inform', [{key:'isCustom',date:''},{key:'room_2_range',date:''}])
                return;
            }
            if(type===1){
                this.$emit('inform', [{key:item,date:''},{key:'cityType',date:''},{key:'lon_latName',date:''}]);
            }else{
                this.$emit('inform',item,type,isMulti);
            }
        },
        //清空条件
        learConditions(){
            this.$emit('learConditions',1);
        },
  }
};
</script>

<style lang="scss" scoped>
    .search-criteria{
        width: 1160px;
        padding: 10px 20px;
        margin: 0 auto;
        background-color: #fff;
        -webkit-box-shadow: 0px 0px 7px #eee;
        box-shadow: 0px 0px 7px #eee;
        margin-top: 20px;
        border: 1px #eee solid;
        border-radius: 6px;
        display: flex;
        padding-bottom: 0;
    }
    .location-title{
        margin-right: 20px;
        width: 8%;
        line-height: 26px;
        text-align: left;
        font-size: 13px;
    }
    .location-list{
        display: flex;
        flex-wrap: wrap;
        width: 82%;
    }
    .location-list li,.clear{
        background-color: #f1f2f4;
        display: inline-block;
        padding: 0 10px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 12px;
        cursor: pointer;
        margin-bottom: 10px;
    }
    .location-list li i{
        margin-left: 4px;
        color: #999;
    }
    .clear{
        background-color: var(--smtc-color-primary);
        color: #fff;
        i{
            margin-right: 4px;
        }
    }
</style>
